import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Inspections_ds_get_inspection_operation_codeService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { operationCodeId?: number, name?: string }): 
  Promise<{ result: { Id?: number, Name?: string, Tasks?: { Id?: number }[] } }> 
  {
    let url = `${environment.backendUrl}api/Inspections/datasources/ds_get_inspection_operation_code/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      operationCodeId?: number, name?: string    }) {
      return false;
    }
}
